import {
  Content,
  ContentHeader,
  Header,
  Page,
  SupportButton,
} from '@backstage/core-components';
import {
  Button,
  Grid,
  Snackbar,
  TextField,
  Typography,
} from '@material-ui/core';
import React, { useEffect, useState } from 'react';
import { microsoftAuthApiRef, useApi } from '@backstage/core-plugin-api';
import { useGetAPI } from '../../Utils/useGetAPI';
import axios from 'axios';
import { useUser } from '../../context/userContext';
import { Alert, AlertTitle } from '@material-ui/lab';

export const FeedbackForm = () => {
  const [feedback, setFeedback] = useState(null);
  const [userData, setUserData] = useState(null);
  const [success, setSuccess] = useState(false);
  const [submitError, setSubmitError] = useState(false);
  const [buttonDisabled, setButtonDisabled] = useState(false);
  function handleTextAreaChange(e) {
    setFeedback(e.target.value);
    if (e.target.value < 1) {
      setFeedback(null);
    }
  }
  const identityAPI = useApi(microsoftAuthApiRef);
  const url = useGetAPI();
  const { getUser } = useUser();

  useEffect(() => {
    (async () => {
      const user = await getUser();
      setUserData({
        user: user,
      });
    })();
  }, [getUser]);

  async function makeAPICall() {
    setButtonDisabled(true);

    const token = await identityAPI.getIdToken();

    const options = {
      url: `${url}/v1/api/devops/feedback`,
      method: 'POST',
      headers: {
        Authorization: `Basic ${token}`,
      },
      data: {
        user: userData.user.email,
        feedback: feedback,
      },
    };

    setSubmitError(false);
    setSuccess(false);

    await axios(options)
      .then(resp => {
        setSuccess(true);
        setFeedback(null);
      })
      .catch(e => {
        setSubmitError(true);
      });

    setButtonDisabled(false);
  }

  function feedbackError() {
    if (feedback === null) {
      return false;
    } else if (feedback.length < 3) {
      return true;
    }
    return false;
  }

  return (
    <Page themeId="tool">
      <Header title="Submit Feedback" />
      <Content>
        <ContentHeader title="">
          <SupportButton>
            <Typography variant="h3" gutterBottom>
              Support
            </Typography>
          </SupportButton>
        </ContentHeader>

        <Grid container spacing={4}>
          <Grid item xs={10}>
            <Typography variant="h6">We want to hear from you.</Typography>
            <Typography variant="body1">
              Let us know what we can do to make things easier for you.
            </Typography>
          </Grid>

          <Grid item xs={10}>
            <TextField
              multiline
              fullWidth
              variant="outlined"
              label="Your feedback here..."
              minRows={12}
              value={feedback || ''}
              onChange={handleTextAreaChange}
              error={feedbackError()}
              helperText={feedbackError() ? 'Feedback too short' : null}
            />
          </Grid>

          <Grid item xs={10} container justifyContent="flex-end">
            <Button
              variant="outlined"
              disabled={
                feedback === null || feedback.length < 3 || buttonDisabled
              }
              onClick={makeAPICall}
            >
              Submit
            </Button>
          </Grid>

          <Snackbar
            autoHideDuration={10000}
            open={success}
            onClose={() => {
              setSuccess(false);
            }}
            anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
          >
            <Alert
              severity="success"
              onClose={() => {
                setSuccess(false);
              }}
            >
              <AlertTitle>Feedback Submitted</AlertTitle>
              Thank you for helping improve the developer portal!
            </Alert>
          </Snackbar>
          <Snackbar
            autoHideDuration={10000}
            open={submitError}
            onClose={() => {
              setSubmitError(false);
            }}
            anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
          >
            <Alert
              severity="error"
              onClose={() => {
                setSubmitError(false);
              }}
            >
              <AlertTitle>Submission Error</AlertTitle>
              Something went wrong. Try again in a few minutes.
            </Alert>
          </Snackbar>
        </Grid>
      </Content>
    </Page>
  );
};
